import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';

function startTaskAutomation(apiClient: ApiClient, taskId: number) {
  return apiClient.PUT('/op/v2/tasks/{id}/start-automation', {
    params: { path: { id: taskId } },
  });
}

export default function useStartTaskAutomationMutation() {
  const apiClient = useApiClient();

  return useMutation<InferFetchData<typeof startTaskAutomation>, ApiError, number>({
    mutationKey: ['StartTaskAutomation'],
    mutationFn: (taskId: number) => throwOnError(startTaskAutomation(apiClient, taskId)),
  });
}
